module.exports = __webpack_public_path__ + "assets/img/huanggongying.0ba57787.jpg";